<template>
  <div class="list_ruangan">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12 v-if="see">
          <v-card>
            <v-card-title>
              <h3><b>Filter Data Peminjaman</b></h3>
            </v-card-title>
             <!--{{items}}-->
            <v-divider></v-divider>
            <div v-if="snackbar.path==='peminjaman'">
              <v-snackbar
                v-model="$store.getters.snackbar.show"
                multi-line="true"
                top=true
                color="green"
              >
                {{ snackbar.message }}
                <v-btn
                  color="pink"
                  flat
                  @click="show = false"
                >
                  Tutup
                </v-btn>
              </v-snackbar>
            </div>
            <v-card-text>
              <v-form class="px-3">
                <v-layout wrap>
                  <v-flex xs12 lg6>
                    <v-text-field
                      label="Nama PIC"
                      v-model="namaPIC">
                    </v-text-field>
                    <v-autocomplete
                      label="Ruangan"
                      :items="kodeRuangan"
                      v-model="namaRuangan"
                    ></v-autocomplete>
                    <v-select
                      name="jenis_penggunaan"
                      label="Jenis Peminjaman"
                      :items="jenisPenggunaan"
                      v-model="isiJenisPenggunaan">
                    </v-select>
                  </v-flex>
                  <v-flex xs12 lg6>
                    <v-menu
                      ref="menu_start"
                      v-model="menu_start"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="date_start"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="date_start"
                          label="Tanggal Pinjam"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="date_start" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" style="min-width:100px;" @click="menu_start = false">Cancel</v-btn>
                        <v-btn text color="primary" style="min-width:100px;" @click="$refs.menu_start.save(date_start); menu_start = false">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                    <v-text-field label="Kode/Nama Mata Kuliah" v-model="deskripsi"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
              <v-btn 
                  class="filter-btn" 
                  color="deep-orange lighten-1"
                  small
                  dark
                  @click="onFilter"
                >
                  <v-icon left>
                    fa fa-filter
                  </v-icon> 
                  Cari
              </v-btn>

              <v-btn 
                  class="filter-btn" 
                  color="grey lighten-2"
                  small
                  @click="onReset"
                >
                  <v-icon left>
                    fa fa-repeat
                  </v-icon> 
                  Reset
              </v-btn>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex lg12>
          <v-card v-if="!see">
            <v-card-title>
              <h3><b>Daftar Peminjaman</b></h3>
            </v-card-title>
          </v-card>
          <v-tabs v-model="active_tab">
            <v-tab
              v-for="tab in tabs"
              :key="tab.index"
              >
              {{tab.name}}
            </v-tab>
            <v-tab-item
              :key="tabs[0].index"
              >
              <v-card>
                <v-card-title>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-data-table :headers="headers"
                                :items="items"
                                :sort-by="'mulai'"
                                :sort-desc="false"
                                item-key="id"
                                class="elevation-1">
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.kodeRuangan }}</td>
                      <td>{{tanggalParse(props.item.mulai)}}</td>
                      <td>{{ props.item.namaPIC }}</td>
                      <td>{{ props.item.jenisPenggunaanRuangan }}</td>
                      <td>{{props.item.deskripsi}}</td>
                      <td>{{props.item.statusPenggunaanRuangan}}</td>
                      <td>
                        <v-tooltip bottom>
                          <v-btn slot="activator"
                                 depressed
                                 icon
                                 fab
                                 dark
                                 color="yellow darken-2"
                                 small
                                 @click="onView(props.item.id,props.item.idRuangan)">
                            <i class="fa fa-search"/>
                          </v-btn>
                          <span>Detail</span>
                        </v-tooltip>

                        <v-tooltip bottom v-if="see2(props.item.jenisPenggunaanRuangan === 'Kuliah Rutin')">
                          <v-btn slot="activator"
                                depressed
                                icon
                                fab
                                dark
                                color="primary"
                                small
                                @click="onEdit(props.item.id)">
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <span>Ubah</span>
                        </v-tooltip>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              :key="tabs[1].index"
              >
              <v-card>
                <v-card-text class="pa-0">
                  <v-data-table :headers="headers" :items="items2" item-key="id" class="elevation-1">
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.kodeRuangan }}</td>
                      <td>{{tanggalParse(props.item.mulai)}}</td>
                      <td>{{ props.item.namaPIC }}</td>
                      <td>{{ props.item.jenisPenggunaanRuangan }}</td>
                      <td>{{props.item.deskripsi}}</td>
                      <td>{{props.item.statusPenggunaanRuangan}}</td>
                      <td>
                        <v-tooltip bottom>
                          <v-btn slot="activator"
                                 depressed
                                 icon
                                 fab
                                 dark
                                 color="yellow darken-2"
                                 small
                                 @click="onView(props.item.id,props.item.idRuangan)">
                            <i class="fa fa-search"/>
                          </v-btn>
                          <span>Detail</span>
                        </v-tooltip>

                        <v-tooltip bottom v-if="see2(props.item.jenisPenggunaanRuangan === 'Kuliah Rutin')">
                          <v-btn slot="activator"
                                depressed
                                icon
                                fab
                                dark
                                color="primary"
                                small
                                @click="onEdit(props.item.id)">
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <span>Ubah</span>
                        </v-tooltip>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              :key="tabs[2].index"
              >
              <v-card>
                <v-card-text class="pa-0">
                  <v-data-table :headers="headers" :items="items3" item-key="id" class="elevation-1">
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.kodeRuangan }}</td>
                      <td>{{tanggalParse(props.item.mulai)}}</td>
                      <td>{{ props.item.namaPIC }}</td>
                      <td>{{ props.item.jenisPenggunaanRuangan }}</td>
                      <td>{{props.item.deskripsi}}</td>
                      <td>{{props.item.statusPenggunaanRuangan}}</td>
                      <td>
                        <v-tooltip bottom>
                          <v-btn slot="activator"
                                 depressed
                                 icon
                                 fab
                                 dark
                                 color="yellow darken-2"
                                 small
                                 @click="onView(props.item.id,props.item.idRuangan)">
                            <i class="fa fa-search"/>
                          </v-btn>
                          <span>Detail</span>
                        </v-tooltip>

                        <v-tooltip bottom v-if="props.item.statusPenggunaanRuangan !== 'Ditolak'">
                          <v-btn slot="activator"
                                depressed
                                icon
                                fab
                                dark
                                color="primary"
                                small
                                @click="onEdit(props.item.id)">
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <span>Ubah</span>
                        </v-tooltip>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              :key="tabs[3].index"
              >
              <v-card>
                <v-card-text class="pa-0">
                  <v-data-table :headers="headers" :items="items4" item-key="id" class="elevation-1">
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.kodeRuangan }}</td>
                      <td>{{tanggalParse(props.item.mulai)}}</td>
                      <td>{{ props.item.namaPIC }}</td>
                      <td>{{ props.item.jenisPenggunaanRuangan }}</td>
                      <td>{{props.item.deskripsi}}</td>
                      <td>{{props.item.statusPenggunaanRuangan}}</td>
                      <td>
                        <v-tooltip bottom>
                          <v-btn slot="activator"
                                 depressed
                                 icon
                                 fab
                                 dark
                                 color="yellow darken-2"
                                 small
                                 @click="onView(props.item.id,props.item.idRuangan)">
                            <i class="fa fa-search"/>
                          </v-btn>
                          <span>Detail</span>
                        </v-tooltip>

                        <v-tooltip bottom v-if="props.item.statusPenggunaanRuangan !== 'Dibatalkan'">
                          <v-btn slot="activator"
                                depressed
                                icon
                                fab
                                dark
                                color="primary"
                                small
                                @click="onEdit(props.item.id)">
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <span>Ubah</span>
                        </v-tooltip>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              :key="tabs[4].index"
              >
              <v-card>
                <v-card-text class="pa-0">
                  <v-data-table :headers="headers" :items="items5" item-key="id" class="elevation-1">
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.kodeRuangan }}</td>
                      <td>{{tanggalParse(props.item.mulai)}}</td>
                      <td>{{ props.item.namaPIC }}</td>
                      <td>{{ props.item.jenisPenggunaanRuangan }}</td>
                      <td>{{props.item.deskripsi}}</td>
                      <td>{{props.item.statusPenggunaanRuangan}}</td>
                      <td>
                        <v-tooltip bottom>
                          <v-btn slot="activator"
                                 depressed
                                 icon
                                 fab
                                 dark
                                 color="yellow darken-2"
                                 small
                                 @click="onView(props.item.id,props.item.idRuangan)">
                            <i class="fa fa-search"/>
                          </v-btn>
                          <span>Detail</span>
                        </v-tooltip>

                        <v-tooltip bottom v-if="see2(props.item.jenisPenggunaanRuangan === 'Kuliah Rutin')
                        && props.item.statusPenggunaanRuangan !== 'Ditolak' && props.item.statusPenggunaanRuangan !== 'Dibatalkan'">
                          <v-btn slot="activator"
                                depressed
                                icon
                                fab
                                dark
                                color="primary"
                                small
                                @click="onEdit(props.item.id)">
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <span>Ubah</span>
                        </v-tooltip>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import {base} from "../../setup-axios"
  import {createJWT} from "../../store/module/helper"
  import { mapGetters,  mapActions} from 'vuex'

export default {
  name: "ruangan",
  data() {
    return {
      headers: [
        {
          text: "Kode Ruangan",
          value: "kodeRuangan"
        },
        {
          text: "Tanggal Peminjaman",
          value: "mulai"
        },
        {
          text: "Nama PIC",
          value: "namaPIC"
        },
        {
          text: "Jenis Peminjaman",
          value: ""
        },
        {
          text: "Deskripsi",
          value: ""
        },
        {
          text: "Status",
          value: ""
        },
        {
          text: "Aksi",
          value: ""
        }
      ],

      items: [],
      items2: [],
      items3: [],
      items4: [],
      items5: [],
      date_start: "",
      menu_start: false,
      active_tab: parseInt(localStorage.getItem("flagTab")),
      tabs: [
      { index: 1, name: 'Diajukan' },
      { index: 2, name: 'Disetujui' },
      { index: 3, name: 'Ditolak'},
      { index: 4, name: 'Dibatalkan'},
      { index: 5, name: 'Semua Peminjaman'},
    ],
      role : localStorage.getItem('role'),
      namaPIC: "",
      namaRuangan: "",
      deskripsi: "",
      kodeRuangan : [],
      jenisPenggunaan : [],
      isiJenisPenggunaan: null,
      activate: false,
      time: 5000,
      show: ""
    }
  },

  created() {
    this.show = this.$store.getters.snackbar.show
    console.log(this.show)

    if(localStorage.getItem("namaruangan") != null
      || localStorage.getItem("pic") != null
      || localStorage.getItem("jenisPenggunaan") != null
      || localStorage.getItem("tglpeminjaman") != null
      || localStorage.getItem("deskrips") != null){

      var ruangan = localStorage.getItem("namaruangan")
      var pic = localStorage.getItem("pic")
      var jenisPenggunaan = localStorage.getItem("jenisPenggunaan")
      var tgl_peminjaman = localStorage.getItem("tglpeminjaman")
      var des = localStorage.getItem("deskrips")


      if(this.role == "admin"){
        console.log("masuk sini")
        if(localStorage.getItem("namaruangan") == ""){
          ruangan = "*"
        }

        if(localStorage.getItem("pic") == ""){
          pic = "*"
        }

        if(localStorage.getItem("jenisPenggunaan") == "null"){
          jenisPenggunaan = "*"
        }

        if(localStorage.getItem("tglpeminjaman") == ""){
          tgl_peminjaman = "*"
        }

        if(localStorage.getItem("deskrips") == ""){
          des = "*"
        }

        base.get("penggunaanRuangan/filter/*/1/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items = []
          this.items = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/*/3/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items2 = []
          this.items2 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/*/2/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items3 = []
          this.items3 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/*/4/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items4 = []
          this.items4 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/*/*/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items5 = []
          this.items5 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })
      }

      if(this.role == "RT"){
        if(localStorage.getItem("namaruangan") == ""){
          ruangan = "*"
        }

        if(localStorage.getItem("pic") == ""){
          pic = "*"
        }

        if(localStorage.getItem("jenisPenggunaan") == "null"){
          jenisPenggunaan = "*"
        }

        if(localStorage.getItem("tglpeminjaman") == ""){
          tgl_peminjaman = "*"
        }

        if(localStorage.getItem("deskrips") == ""){
          des = "*"
        }
        base.get("penggunaanRuangan/filter/non-akademik/1/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/*",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items = []
          this.items = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/non-akademik/3/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/*",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items2 = []
          this.items2 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/non-akademik/2/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/*",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items3 = []
          this.items3 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/non-akademik/4/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/*",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items4 = []
          this.items4 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/non-akademik/*/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/*",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items5 = []
          this.items5 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })
      }

      if(this.role == "ruang"){
        if(localStorage.getItem("namaruangan") == ""){
          ruangan = "*"
        }

        if(localStorage.getItem("pic") == ""){
          pic = "*"
        }

        if(localStorage.getItem("jenisPenggunaan") == "null"){
          jenisPenggunaan = "*"
        }

        if(localStorage.getItem("tglpeminjaman") == ""){
          tgl_peminjaman = "*"
        }

        if(localStorage.getItem("deskrips") == ""){
          des = "*"
        }
        base.get("penggunaanRuangan/filter/akademik/1/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items = []
          this.items = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/akademik/3/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items2 = []
          this.items2 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/akademik/2/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items3 = []
          this.items3 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/akademik/4/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items4 = []
          this.items4 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/akademik/*/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items5 = []
          this.items5 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })
      }

    }
    else {
      if(localStorage.getItem("role") == "admin"){
        base.get("penggunaanRuangan/admin/status/1",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items = resp.data.result
        })

        base.get("penggunaanRuangan/admin/status/3",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items2 = resp.data.result
        })

        base.get("penggunaanRuangan/admin/status/2",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items3 = resp.data.result
        })

        base.get("penggunaanRuangan/admin/status/4",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items4 = resp.data.result
        })

        base.get("penggunaanRuangan",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items5 = resp.data.result
        })
      }

      if(localStorage.getItem("role") == "RT"){
        base.get("penggunaanRuangan/non-akademik/status/1",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items = resp.data.result
        })

        base.get("penggunaanRuangan/non-akademik/status/3",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items2 = resp.data.result
        })

        base.get("penggunaanRuangan/non-akademik/status/2",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items3 = resp.data.result
        })

        base.get("penggunaanRuangan/non-akademik/status/4",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items4 = resp.data.result
        })

        base.get("penggunaanRuangan/non-akademik/status/0",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items5 = resp.data.result
        })
      }

      if(localStorage.getItem("role") == "ruang"){
        base.get("penggunaanRuangan/akademik/status/1",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items = resp.data.result
        })

        base.get("penggunaanRuangan/akademik/status/3",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items2 = resp.data.result
        })

        base.get("penggunaanRuangan/akademik/status/2",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items3 = resp.data.result
        })

        base.get("penggunaanRuangan/akademik/status/4",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items4 = resp.data.result
        })

        base.get("penggunaanRuangan/akademik/status/0",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items5 = resp.data.result
        })
      }

      if(localStorage.getItem("role") == "mhs" || localStorage.getItem("role") == "dos" || this.role == "akad"){
        base.get("penggunaanRuangan/filter/usernamePengaju/" + localStorage.getItem("user") + "/status/1",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items = resp.data.result
        })

        base.get("penggunaanRuangan/filter/usernamePengaju/" + localStorage.getItem("user") + "/status/3",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items2 = resp.data.result
        })

        base.get("penggunaanRuangan/filter/usernamePengaju/" + localStorage.getItem("user") + "/status/2",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items3 = resp.data.result
        })

        base.get("penggunaanRuangan/filter/usernamePengaju/" + localStorage.getItem("user") + "/status/4",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items4 = resp.data.result
        })

        base.get("penggunaanRuangan/filter/usernamePengaju/" + localStorage.getItem("user") + "/status/0",
          {
            headers: {
              Authorization: createJWT()
            }
          }
        ).then((resp) => {
          this.items5 = resp.data.result
        })
      }
    }

    base.get("ruangan/dropdown",
           {
             headers: {
               Authorization: createJWT()
             }
           }
    ).then((resp) => {
      for(var i=0; i < resp.data.result.length;i++){
        this.kodeRuangan.push(resp.data.result[i].nama)
      }
    })

    base.get("jenisPenggunaanRuangan",
           {
             headers: {
               Authorization: createJWT()
             }
           }
    ).then((resp) => {
      for(var i=0; i < resp.data.result.length;i++){
        this.jenisPenggunaan.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
      }
    })
  },
  computed:{
    ...mapGetters(["snackbar"]),
    showData:()=>{
      console.log(snackbar.show)
      this.show = this.snackbar.show
    },

    see: function () {
      this.role;
      return this.role == "admin" || this.role == "RT" || this.role == "ruang";
    }
  },
  methods: {
    formatDate(date) {
    console.log("datenya" + date)
      if (date ==="*") {
        console.log("here null")
        return "*"
      }
      else {
        console.log(date)
        const [year, month, day] = date.split("-")
        console.log({year})
        return `${day}-${month}-${year}`
      }
    },
    onView(id,idRuangan) {
      this.$router.push("/peminjaman/View/" + id + "/" + idRuangan)
    },
    onTambah() {
      this.$router.push("/ruangan/Add")
    },
    onEdit(id) {
      this.$router.push("/peminjaman/Edit/" + id)
    },
    onFilter(){
      var ruangan = this.namaRuangan
      var pic = this.namaPIC
      var jenisPenggunaan = this.isiJenisPenggunaan
      var tgl_peminjaman = this.date_start
      var des = this.deskripsi

      localStorage.setItem("namaruangan", this.namaRuangan)
      localStorage.setItem("pic", this.namaPIC)
      localStorage.setItem("jenisPenggunaan", this.isiJenisPenggunaan)
      localStorage.setItem("tglpeminjaman", this.date_start)
      localStorage.setItem("deskrips", this.deskripsi)

      if(this.role == "admin" || this.role == "akad"){
        if(this.namaRuangan == ""){
          ruangan = "*"
        }

        if(this.namaPIC == ""){
          pic = "*"
        }

        if(this.isiJenisPenggunaan == null){
          jenisPenggunaan = "*"
        }

        if(this.date_start == ""){
          tgl_peminjaman = "*"
        }

        if(this.deskripsi == ""){
          des = "*"
        }

        base.get("penggunaanRuangan/filter/*/1/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items = []
          this.items = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/*/3/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items2 = []
          this.items2 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/*/2/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items3 = []
          this.items3 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/*/4/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items4 = []
          this.items4 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/*/*/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items5 = []
          this.items5 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })
      }

      if(this.role == "RT"){
        if(this.namaRuangan == ""){
          ruangan = "*"
        }

        if(this.namaPIC == ""){
          pic = "*"
        }

        if(this.isiJenisPenggunaan == null){
          jenisPenggunaan = "*"
        }

        if(this.date_start == ""){
          tgl_peminjaman = "*"
        }
        base.get("penggunaanRuangan/filter/non-akademik/1/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/*",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items = []
          this.items = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/non-akademik/3/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/*",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items2 = []
          this.items2 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/non-akademik/2/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/*",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items3 = []
          this.items3 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/non-akademik/4/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/*",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items4 = []
          this.items4 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/non-akademik/*/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/*",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items5 = []
          this.items5 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })
      }

      if(this.role == "ruang"){
        if(this.namaRuangan == ""){
          ruangan = "*"
        }

        if(this.namaPIC == ""){
          pic = "*"
        }

        if(this.isiJenisPenggunaan == null){
          jenisPenggunaan = "*"
        }

        if(this.date_start == ""){
          tgl_peminjaman = "*"
        }
        if(this.deskripsi == ""){
          des = "*"
        }
        base.get("penggunaanRuangan/filter/akademik/1/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items = []
          this.items = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/akademik/3/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items2 = []
          this.items2 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/akademik/2/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items3 = []
          this.items3 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/akademik/4/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items4 = []
          this.items4 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })

        base.get("penggunaanRuangan/filter/akademik/*/" + ruangan + "/"
          + pic + "/" + this.formatDate(tgl_peminjaman) + "/" + jenisPenggunaan
          + "/" + des,
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items5 = []
          this.items5 = resp.data.result
        })
          .catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            this.items = []
          })
      }
    },

    onReset(){
      this.namaRuangan = ""
      this.namaPIC = ""
      this.isiJenisPenggunaan = null
      this.date_start = ""
      this.deskripsi = ""

      localStorage.removeItem("namaruangan")
      localStorage.removeItem("pic")
      localStorage.removeItem("jenisPenggunaan")
      localStorage.removeItem("tglpeminjaman")
      localStorage.removeItem("deskrips")

      if(this.role == "admin"){
        base.get("penggunaanRuangan/admin/status/1",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items = resp.data.result
        })

        base.get("penggunaanRuangan/admin/status/3",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items2 = resp.data.result
        })

        base.get("penggunaanRuangan/admin/status/2",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items3 = resp.data.result
        })

        base.get("penggunaanRuangan/admin/status/4",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items4 = resp.data.result
        })

        base.get("penggunaanRuangan",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items5 = resp.data.result
        })
      }

      if(this.role == "RT"){
        base.get("penggunaanRuangan/non-akademik/status/1",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items = resp.data.result
        })

        base.get("penggunaanRuangan/non-akademik/status/3",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items2 = resp.data.result
        })

        base.get("penggunaanRuangan/non-akademik/status/2",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items3 = resp.data.result
        })

        base.get("penggunaanRuangan/non-akademik/status/4",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items4 = resp.data.result
        })

        base.get("penggunaanRuangan/non-akademik/status/0",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items5 = resp.data.result
        })
      }

      if(this.role == "ruang"){
        base.get("penggunaanRuangan/akademik/status/1",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items = resp.data.result
        })

        base.get("penggunaanRuangan/akademik/status/3",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items2 = resp.data.result
        })

        base.get("penggunaanRuangan/akademik/status/2",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items3 = resp.data.result
        })

        base.get("penggunaanRuangan/akademik/status/4",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items4 = resp.data.result
        })

        base.get("penggunaanRuangan/akademik/status/0",
           {
             headers: {
               Authorization: createJWT()
             }
           }
        ).then((resp) => {
          this.items5 = resp.data.result
        })
      }
    },

    tanggalParse(value){
      return value.substring(0,10)
    },

    seen(){
      if(localStorage.getItem("role") == "admin"){
        return true
      }

      else {
        return false
      }
    },

    see2(item){
      if(item || localStorage.getItem("role") == "admin" || localStorage.getItem("role") == "RT"
        || localStorage.getItem("role") == "ruang" ){

        return true
      }

      else {
        return false
      }
    }
  }
}
</script>

<style scoped>

</style>